import { Component, OnInit, ViewChild, EventEmitter, ViewEncapsulation } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { MatPaginator, MatSort, MatSlideToggle } from '@angular/material';
import { MatTableCustomDataSource, MatTableCustomApi, MatTableCustomDao } from './../../../helpers/mat-table-datasource';

import * as moment from 'moment';

import { environment } from './../../../../environments/environment';

import { FileUploader, FileItem } from 'ng2-file-upload';

import { ExtraService } from './../../../services/extra.service';
import { BookService } from './../../../services/book.service';
import { AppComponent } from './../../../app.component';

import { Extra } from '../../../models/Extra';
import { Collana } from '../../../models/Collana';
import { Onix } from '../../../models/Onix';

@Component({
  selector: 'app-extra-form',
  templateUrl: './extra-form.component.html',
  styleUrls: ['./extra-form.component.css'],
  providers: [BookService, ExtraService]
})
export class ExtraFormComponent implements OnInit {
  ean13: string;
  collana: Collana;
  publisher: string;
  coverpath: string;
  tipoProdotto: Onix;

  displayedColumns = ['_id', 'dtcont', 'descrizione', 'openfile', 'filename', 'categoria'];
  database: MatTableCustomDao<Extra> | null;
  dataSource: MatTableCustomDataSource<Extra, MatTableCustomApi<Extra>>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  filter: EventEmitter<String> = new EventEmitter<String>();

  wmodel: Extra = new Extra();
  dirty: boolean;
  loading: boolean;
  persisting: boolean;
  confirm2remove: boolean;
  updateMode: boolean;
  @ViewChild('f') form: FormGroup;

  selectedIdbackup: string;
  attachmentUrl: string;

  public uploader: FileUploader = new FileUploader({ url: environment.server.url + '/extra/uploadAttachment' });

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public extraService: ExtraService,
    private bookService: BookService,
    public parent: AppComponent) {
    this.publisher = environment.publisher;
  }

  get filters(): any {
    return {
      ean13: this.ean13
    }
  }

  highlight(row) {
    this.extraService.selected = row._id;
  }

  ngOnInit() {
    this.ean13 = this.route.snapshot.paramMap.get('ean13');
    this.publisher = environment.publisher;
    this.attachmentUrl = environment.extra.media;
    setTimeout(() => {
      this.bookService.getBook(this.ean13).subscribe(result => {
        console.log(result);
        if (result.success && result.book) {
          let wmodel = this.bookService.fromMongo(result.book);
          this.collana = wmodel.collana;
          this.tipoProdotto = wmodel.tipoProdotto;
          this.coverpath = this.bookService.getBookCoverPath(wmodel.ean13);
        }
      })
    }, 0)

    this.database = new MatTableCustomDao(this.extraService);
    this.dataSource = new MatTableCustomDataSource(
      this.database!,
      this.paginator,
      this.sort,
      this.filter,
      false);

    this.filter.emit(this.filters);
    this.filter.subscribe((res) => {
      console.log('***********************', res, this.selectedIdbackup)
      if (this.selectedIdbackup) {
        this.extraService.selected = this.selectedIdbackup;
        this.selectedIdbackup = undefined;
      }
    })

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      let wo = JSON.parse(response);
      console.log(item._file.name, wo.success);
      console.log(wo);

      if (wo.success) {
        this.wmodel.filename = wo.attachment.filename;

        this.extraService.persist(this._fromModel(this.wmodel)).subscribe((res) => {
          console.log(res)
          if (res.success && res.result) {
            this.wmodel = this._toModel(res.result.value);
            this.synchSito(this.ean13, false);
          }
        })
      } else {
      }
    }
  }

  persist() {
    this.persisting = true;
    this.parent.addToast('', 'salvataggio in corso...', ((wid) => {
      setTimeout(() => {
        this.extraService.persist(this._fromModel(this.wmodel)).subscribe((res) => {
          console.log(res)
          if (res.success && res.result) {
            this.wmodel = this._toModel(res.result.value);
            this.synchSito(this.ean13, true);
          }
          this.parent.clearToast(wid);
          this.filter.emit(this.filters);
          this.persisting = false;
          this.parent.operSnackBar(res.success, res.success ? 'salvataggio completato' : res.err)
        })
      }, 2000);
    }))
  }

  remove() {
    if (this.extraService.selected) {
      this.persisting = true;
      this.parent.addToast('', 'eliminazione in corso...', ((wid) => {
        setTimeout(() => {
          let extra2remove = new Extra({
            _id: this.extraService.selected
          })
          this.extraService.remove(extra2remove).subscribe((res) => {
            console.log(res)
            if (res.success) {
              this.confirm2remove = false;
              this.synchSito(this.ean13, true);
            }


            this.parent.clearToast(wid);
            this.filter.emit(this.filters);
            this.persisting = false;
            this.parent.operSnackBar(res.success, res.success ? 'eliminazione completata' : res.err)
          })
        }, 1000);
      }))
    }
  }

  synchSito(ean13: string, popupToast: boolean) {
      setTimeout(() => {
        this.bookService.callSitoEndpoint(ean13)
          .subscribe(res => {
            if(popupToast) {
              this.parent.addPopupToast('', res.success ? 'sincronizzazione portale completata' : 'sincronizzazione portale fallita', 5000, res.success, null)
            }
            console.log(res);
          },
          error => {
            console.log(error);
            this.parent.addPopupToast('', 'sincronizzazione portale fallita', 5000, false, null)
          })
      }, 1000);

  }

  add() {
    this.updateMode = true;
    this.wmodel = new Extra({
      ean13: this.ean13,
      dtcont: new Date()
    });
  }

  discard() {
    this.updateMode = false;
  }

  _toModel(o: any): Extra {
    if (o) {
      if (o.dtcont) {
        o.dtcont = moment(o.dtcont).format('YYYY-MM-DD');
      }
      return new Extra(o);
    } else {
      return new Extra();
    }
  }

  _fromModel(o: any): Extra {
    if (o) {
      if (o.dtcont) {
        o.dtcont = moment(o.dtcont).format('YYYY-MM-DD 00:00:00');
      }
      return new Extra(o);
    } else {
      return new Extra();
    }
  }

  edit() {
    this.selectedIdbackup = this.extraService.selected;
    this.updateMode = true;
    this.loading = true;
    setTimeout(() => {
      this.extraService.getExtra(this.extraService.selected).subscribe(result => {
        console.log(result);
        this.wmodel = this._toModel(result.extra);
        console.log(this.wmodel);
        this.loading = false;
      })
    }, 1000);
  }

  apriSchedaLibro() {
    this.router.navigate(['/book/' + this.ean13]);
  }

  gotoSito() {
    window.open(environment.urlPortale + '/control/dettagliolibro?ean13=' + this.ean13, "_blank");
  }

  go2search() {
    this.router.navigate(['/book/search']);
  }

  getTitle(): string {
    return "extra";
  }

}



// WEBPACK FOOTER //
// ./src/app/components/extra/extra-form/extra-form.component.ts